import { DownloadKsyosDesktopLink } from './DownloadKsyosDesktopLink';

export function HolterDownloadText() {
    return (
        <>
            We kunnen niet controleren of er een recorder is aangesloten. Het kan zijn dat de Ksyos koppeling nog niet
            op deze computer is geïnstalleerd. <DownloadKsyosDesktopLink /> of neem contact op met de servicedesk via
            020 600 00 60.
        </>
    );
}
